<template>
    <el-input
        :placeholder="placeholder"
        :type="type"
        :rows="rows"
        :size="size"
        :disabled="disabled"
        v-model="model"
        @blur="trimValue"
        @keyup.enter.native="keyUpEnter"
    >
        <slot slot="append"></slot>
    </el-input>
</template>
<script>
import { trim } from "lodash";
export default {
    name: "InputTrim",
    data() {
        return {
            model: ""
        };
    },

    props: {
        placeholder: {
            type: String,
            required: false
        },
        value: {
            type: [String, Number],
            default: ""
        },
        type: {
            type: String,
            default: ""
        },
        rows: {
            type: Number,
            default: 5
        },
        size: {
            type: String,
            default: 'medium'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler(val) {
                this.model = val;
            },
            immediate: true
        },
        model: {
            handler(val) {
                this.$emit("input", val);
            }
        }
    },
    methods: {
        trimValue() {
            this.model = trim(this.model);
        },
        keyUpEnter() {
            this.$emit("keyUpEnter");
        }
    }
};
</script>



// WEBPACK FOOTER //
// website/subComponents/InputTrim.vue